
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.25 21.75a.75.75 0 01-.75-.75h-.75a.75.75 0 010-1.5h2.029a.59.59 0 00.546-.825.589.589 0 00-.324-.315l-2.064-.826a2.081 2.081 0 01-1.315-1.945c0-.559.219-1.084.614-1.478a2.075 2.075 0 011.263-.6V13.5a.75.75 0 011.501 0h.75a.75.75 0 010 1.5h-2.034a.593.593 0 00-.222 1.142l2.063.825a2.093 2.093 0 011.169 2.715A2.078 2.078 0 0118 20.989V21a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"d":"M17.25 24c-3.722 0-6.75-3.028-6.75-6.75s3.028-6.75 6.75-6.75S24 13.528 24 17.25 20.972 24 17.25 24zm0-12C14.355 12 12 14.355 12 17.25s2.355 5.25 5.25 5.25 5.25-2.355 5.25-5.25S20.145 12 17.25 12z"}}),_c('path',{attrs:{"d":"M3.75 24a.747.747 0 01-.746-.675L2.321 16.5H.75a.75.75 0 01-.75-.75V13.5a5.978 5.978 0 012.702-5.013.748.748 0 011.039.215L6 12.135l2.26-3.437a.758.758 0 01.627-.338c.147 0 .29.043.413.125a6.073 6.073 0 011.92 2.055.747.747 0 01-.282 1.023.752.752 0 01-1.022-.282 4.621 4.621 0 00-.85-1.077l-2.438 3.708a.746.746 0 01-.628.327.743.743 0 01-.627-.327l-2.44-3.708A4.459 4.459 0 001.5 13.5V15H3c.387 0 .708.29.746.675l.683 6.825h3.143l.289-2.898a.746.746 0 01.828-.671.738.738 0 01.499.271c.127.155.186.35.166.549l-.357 3.573A.748.748 0 018.25 24h-4.5zM11.25 8.25c-.674 0-1.847-.264-2.521-1.933C8.027 7.068 7.05 7.5 6 7.5s-2.027-.432-2.729-1.183C2.597 7.986 1.424 8.25.75 8.25a.75.75 0 010-1.5c1.444 0 1.5-2.971 1.5-3.001C2.25 1.682 3.932 0 6 0s3.75 1.682 3.75 3.75c0 .029.055 3 1.5 3a.75.75 0 010 1.5zM6 1.5c-1.241 0-2.25 1.009-2.25 2.25S4.759 6 6 6s2.25-1.009 2.25-2.25S7.241 1.5 6 1.5z"}})])
          )
        }
      }
    